import MobileHomeWeather from './MobileHomeWeather';

export default MobileHomeWeather;
